import cacheLs from "../cacheLs"

export default {
  addSchool (state, data) {
    state.selectedSchool = { ...data }
    cacheLs.set_school(data)
  }
}
